import { cart, settings, user } from 'core';
import { ProductList } from 'ui/components';

import ProductsShowcasesEmpty from '../../../ProductsEmpty/ProductsEmpty';
import ProductListCard from '../ProductCardList/ProductListCard';

import type { ProductListProps } from './ProductList.d';

const ProductListContainer = ({ data, itemsPerRowDesktop = '4', widgetKey }: ProductListProps) => {
  const { addItem, updateItem } = cart.commands.useCartCommand();
  const isBuyIntentionFeatureActive = settings.hooks.useFeatureToggle('buyIntention');
  const { setBuyIntention } = user.commands.useUserCommand();
  const { isBuyIntention } = user.hooks.useIsBuyIntention();
  const isResaleIntention = user.selectors.useIsResaleIntention();
  const isAutoStartEnabled = user.selectors.useIsAutoStartEnabled();
  const hasItems = data.length > 0;

  return hasItems ? (
    <ProductList data-items-desktop={itemsPerRowDesktop} id={widgetKey}>
      {data.map((cardData) => (
        <ProductListCard
          key={`productCard-${cardData.productCode}`}
          cardData={cardData}
          addItem={addItem}
          updateItem={updateItem}
          isBuyIntentionFeatureActive={isBuyIntentionFeatureActive}
          isBuyIntention={isBuyIntention}
          setBuyIntention={setBuyIntention}
          isResaleIntention={isResaleIntention}
          isAutoStartEnabled={isAutoStartEnabled}
        />
      ))}
    </ProductList>
  ) : (
    <ProductsShowcasesEmpty />
  );
};

export default ProductListContainer;
